import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "pencilFilled"
const PencilFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18.31 10.5 8.56 20.25H21.75V21.75H3C2.586 21.75 2.25 21.414 2.25 21V16.94L13.5 5.69zM16.94 2.25C17.525 1.665 18.475 1.665 19.06 2.25L21.75 4.94C22.336 5.526 22.336 6.475 21.75 7.06L19.5 9.31 14.69 4.5z" />
        </svg>
      }
    </span>
  )
}
export default PencilFilledIcon
